import styled, { keyframes, css } from 'styled-components';
import { NotificationType } from './types';
import { Typography } from '../Typography';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

export const NotificationContainer = styled(Typography).attrs({
  tag: 'title_2'
})`
  display: flex;
  cursor: pointer;
  align-content: center;
  justify-content: center;
  width: 100%;
  padding: 20px 15px;
  background-color: ${({ type, theme: { colors } }) =>
    type === NotificationType.Success
      ? colors.systemColors.green
      : colors.systemColors.red};
  color: ${({ theme: { colors } }) => colors.background.primary};
  ${({ $isClosing }) => css`
    animation: ${$isClosing ? fadeOut : fadeIn} 0.5s ease-in-out forwards;
  `};

  position: fixed;
  top: env(safe-area-inset-top);
  left: 0;
  right: 0;
`;
